
import { api_host, api_auth} from '../../common/globals/constants';
//export const getWeighing='hola'
export const getWeighing = (client, token, key) => 
    fetch(api_host+`/reporte/online/indicadores/Weighing/?client=${client}&token=${token}&key=${key}`)
.then(response => response.json())
